import { render, staticRenderFns } from "./ModalShowExamDetail.vue?vue&type=template&id=c4ad04bc&scoped=true"
import script from "./ModalShowExamDetail.vue?vue&type=script&lang=js"
export * from "./ModalShowExamDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalShowExamDetail.vue?vue&type=style&index=0&id=c4ad04bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ad04bc",
  null
  
)

export default component.exports